(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/ball-row/assets/javascripts/ball-row-joker.js') >= 0) return;  svs.modules.push('/components/tur/ball-row/assets/javascripts/ball-row-joker.js');
'use strict';

svs.tur = svs.tur || {};
svs.tur.ball = svs.tur.ball || {};
svs.tur.ball.row = svs.tur.ball.row || {};
class RowJoker extends svs.tur.ball.row.Default {
  constructor(_ref) {
    let _ref$balls = _ref.balls,
      balls = _ref$balls === void 0 ? [] : _ref$balls,
      _ref$numbers = _ref.numbers,
      numbers = _ref$numbers === void 0 ? [] : _ref$numbers,
      description = _ref.description,
      order = _ref.order,
      size = _ref.size,
      winPlan = _ref.winPlan;
    super({
      balls,
      numbers,
      description,
      order,
      size,
      winPlan,
      BallClass: svs.tur.ball.Joker
    });
    this._numbers = numbers;
    this._balls = balls;
  }
  classNames() {
    return ['ball-row-joker'];
  }
  addWinInfo() {
    if (this.winPlan) {
      this.winInfo = this.winPlan;
      return;
    }
    this.winInfo = new svs.tur.ball.row.extensions.WinInfoJoker(this);
    this.$el.appendChild(this.winInfo.render());
  }
  markAsWin() {
    if (!this.isWin) {
      this.addClass('ball-row-win');
      this.isWin = true;
    }
  }
}
svs.tur.ball.row.Joker = RowJoker;

 })(window);